import styled from 'styled-components';

export const FilterListRoot = styled.div`
  ul {
    list-style: disc;
    padding-left: 1em;
  }
`;
